import { type Tools } from '~/state/atoms/toolsAtoms';
import ModifierCountSummary from './drawingConstraints/ModifierCountSummary';
import { useToolOptionsSummary } from './useToolOptionsSummary';

interface ToolOptionsSummaryProps {
    tool: Tools;
    /**
     * The tool's options carry the Modifiers: the line also reads how many
     * apply, and how many are on but apply to nothing.
     */
    showsModifiers?: boolean;
}

/**
 * The values in force for a contouring tool, on one line, such as
 * `1.5 cm / 2D / 1 active / 1 inactive`: its sizes and modes as
 * {@link useToolOptionsSummary} reads them and, for a tool whose options
 * carry the Modifiers, the count of the modifiers that apply and of those
 * on but applying to nothing. It subscribes to them itself, so a change to
 * an option re-renders this line only, and only a line that shows the count
 * reads the modifiers. Renders nothing while there is no value to read.
 */
export default function ToolOptionsSummary({
    tool,
    showsModifiers = false,
}: ToolOptionsSummaryProps) {
    const values = useToolOptionsSummary(tool);
    return (
        <>
            {values}
            {showsModifiers && (
                <ModifierCountSummary afterValues={values !== undefined} />
            )}
        </>
    );
}
